class Burger {
    stateClasses = {
        active: 'nav--open-mobile',
        scroll: 'no-scroll',
        header: 'header--background',
        subNav: 'subnav--open'
    };

    open = false;

    constructor($el, headerInstance) {
        this.$el = $el;
        this.$navigation = $('.header');
        this.$body = $('body');
        this.headerInstance = headerInstance;
        this.init();
    }

    init() {
        this.$el.on('click', () => this.toggleNav());
    }

    toggleNav() {
        this.open ? this.closeNav() : this.openNav();
    }

    openNav() {
        this.$navigation.addClass(this.stateClasses.active);
        this.$body.addClass(this.stateClasses.scroll);
        this.open = true;
    }

    closeNav() {
        this.$navigation.removeClass([
            this.stateClasses.active,
            this.stateClasses.header,
            this.stateClasses.subNav
        ].join(' '));
        this.$body.removeClass(this.stateClasses.scroll);
        this.open = false;


        if (this.headerInstance?.updateHeaderBackground) {
            this.headerInstance.updateHeaderBackground();
        }
    }
}

export default Burger;
